export const formatCurrency = (amount: number | null | undefined): string => {
  if (amount == null) return '-';

  return `¥ ${amount.toLocaleString('ja-JP')}`;
};
